import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import '../src/styles/main.scss';
import Routes from './routes';

const container = document.getElementById('root')!;
const root = createRoot(container);

declare global {
  interface Window {
    dataLayer: any,
  }
}

root.render(
  <Provider store={store}>
    <Routes />
  </Provider>
);

reportWebVitals();
